import { IRootState } from '../../../store'
import { ICmdFacChartDefaults } from '../store/configurations.types'

export const getCmdChartDefaultsSelector = (state: IRootState): ICmdFacChartDefaults =>
  state.configurations.cmdFacChartDefaults
